import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "unauthorized",
    templateUrl: "./unauthorized.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class UnauthorizedComponent {

}
